import React, { useEffect } from 'react';
import { makeStyles } from '@material-ui/core';
import { useImagesLoaded } from '../../hooks/useImagesLoaded';
import { useShareablesTemplateRoot } from '../../hooks/useShareablesTemplateRoot';
import { COLOR_WHITE } from '../colors';
import { Badge } from './Badge';
const useStyles = makeStyles((theme)=> ({
    wrap: {
        fontFamily: ['"LL Circular Pro"', 'Arial', 'Helvetica', 'sans-serif'],
        position: 'relative',
        width: '100%',
        height: '100%',
        backgroundSize: 'cover',
        backgroundPosition: 'center',
        backgroundRepeat: 'no-repeat',
        boxSizing: 'border-box',
        display: 'flex',
        flexDirection: 'column',
        padding: 24,
        justifyContent: 'center',
        textAlign: 'center',
    },
    container: {
        position: 'relative',
    },
    listpackName: {
        padding: '16px 24px',
        backgroundColor: COLOR_WHITE,
        display: 'inline-block',
        fontWeight: 600,
        fontSize: 48,
    },
    presentedByContainer: {
        marginTop: 24,
    },
    presentedBy: {
        display: 'inline-block',
        padding: '8px 12px',
        backgroundColor: 'rgba(0,0,0,0.6)',
        color: COLOR_WHITE,
        fontSize: 18,
    },
    headshotContainer: {
        position: 'absolute',
        width: '100%',
        top: -42,
        textAlign: 'center',
    },
    headshot: {
        width: 80,
        height: 80,
        borderRadius: '50%',
        margin: '0 auto',
        boxShadow: '0 0 4px rgba(0,0,0,0.5)',
        backgroundSize: 'cover',
        backgroundPosition: 'center',
        backgroundRepeat: 'no-repeat',
    },
    badgeWrap: {
        position: 'absolute',
        top: 24,
        left: 24,
    },
    watermark: {
        position: 'absolute',
        left: '50%',
        bottom: '30%',
        zIndex: 9999,

        '& img': {
            position: 'relative',
            left: '-50%',
        },
    }
}));

export default function ListpackShareable(props) {
    const {
        rootClasses,
        parsedData,
        onImagesLoaded,
    } = useShareablesTemplateRoot(props);
    const classes = Object.assign({}, rootClasses, useStyles(props));
    const {
        hero_image,
        hero_color,
        name,
        areas,
        agent: {
            name: agentName,
            headshot,
        } = {},
        watermark = false,
    } = parsedData || {};
    const loadedBgs = useImagesLoaded([hero_image]);
    const areasList = (areas || '')
        .split(',')
        .flatMap((a)=> a ? [a.trim()]: []);
    const isTopXListpack = (/^Top\s\d+/).test(name);
    const formattedArea = (
            areasList.length > 0 &&
            isTopXListpack // display area only for "Top X ..." type names
        )
        ? `${areasList.length > 1 ? 'around' : 'in'} ${areasList[0]}`
        : null;

    useEffect(() => {
        if(loadedBgs && !window.isLoaded) {
            if(typeof onImagesLoaded === 'function') {
                onImagesLoaded();
            } else {
                window.isLoaded = true;
            }
        }
    }, [loadedBgs, onImagesLoaded]);

    if(!parsedData) return null;
    if(!hero_image) return null;

    return (
        <>
            <link rel="stylesheet" href="./css/ll-circular-pro.css" />
            <div className={classes.root} id="templateRoot">
                <div className={classes.viewport}>
                    <div className={classes.wrap}
                        style={{
                            backgroundColor: `url("${hero_color}")`,
                            backgroundImage: `url("${hero_image}")`,
                        }}
                    >
                        <div className={classes.container} style={{ marginTop: headshot ? 42 : 0 }}>
                            {name && (
                                <>
                                    <div className={classes.listpackName} style={{ marginTop: headshot ? 24 : 0 }}>{name}</div>
                                    {formattedArea && (<br/>)}
                                    {formattedArea && (
                                        <div className={classes.listpackName} style={{ marginTop: 8 }}>{formattedArea}</div>
                                    )}
                                </>
                            )}
                            {headshot && (
                                <div className={classes.headshotContainer}>
                                    <div className={classes.headshot}
                                        style={{backgroundImage: `url("${headshot}")`}}
                                    ></div>
                                </div>
                            )}

                            {agentName && (
                                <div className={classes.presentedByContainer}>
                                    <div className={classes.presentedBy}>Presented By {agentName}</div>
                                </div>
                            )}
                        </div>

                        {isTopXListpack && (<div className={classes.badgeWrap}><Badge width={180} height={180} /></div>)}
                        {watermark && (<div className={classes.watermark}>
                            <img src="./images/watermark-stamp.svg" alt="Watermark" />
                        </div>)}
                    </div>
                </div>
            </div>
        </>
    );
}
